import React, {useState, useEffect} from "react";
import { Container, Row, Col, Button, Card, Modal, Form } from "react-bootstrap";
import styles from "./Household.module.css";
import { IoClose } from "react-icons/io5";

// For Ionicons v4
import { IoMdClose } from "react-icons/io"; 
import Swal from "sweetalert2";
import NewHeader from "../../Components/NewHeader";


const members = [
  {
    initials: "AA",
    name: "Adunola Akinyemi",
    role: "Head of Household",
    dob: "14 Mar 1988",
    gender: "Female",
    education: "Secondary",
    occupation: "Petty Trading",
    highlight: true,
    color: "#1b5e20",
  },
  {
    initials: "KA",
    name: "Kemi Adeyemi",
    role: "Daughter",
    dob: "05 Oct 2010",
    gender: "Female",
    education: "Secondary",
    occupation: "Student",
    color: "#c25b00",
  },
  {
    initials: "BA",
    name: "Biodun Adeyemi",
    role: "Son",
    dob: "12 Dec 2014",
    gender: "Male",
    education: "Primary",
    occupation: "Student",
    color: "#0f7c8b",
  },
  {
    initials: "DA",
    name: "Damilare Adeyemi",
    role: "Son",
    dob: "16 Mar 2017",
    gender: "Male",
    education: "Primary",
    occupation: "Student",
    color: "#2e7d32",
  },
];

// const MemberCard = ({ member }) => {
//   return (
//     <Card className={`${styles.card} ${member.highlight ? styles.highlight : ""}`}>
//       <Card.Body>
//         <div className={styles.avatar} style={{ background: member.color }}>
//           {member.initials}
//         </div>

//         <h5 className={styles.name}>{member.name}</h5>
//         <p className={styles.role}>{member.role}</p>

//         <div className={styles.infoRow}>
//           <span>Date of Birth</span>
//           <span>{member.dob}</span>
//         </div>

//         <div className={styles.infoRow}>
//           <span>Gender</span>
//           <span>{member.gender}</span>
//         </div>

//         <div className={styles.infoRow}>
//           <span>Education</span>
//           <span>{member.education}</span>
//         </div>

//         <div className={styles.infoRow}>
//           <span>Occupation</span>
//           <span>{member.occupation}</span>
//         </div>

//         <div className={styles.actions}>
//           <Button variant="outline-success" className={styles.btn}>
//             Edit Profile
//           </Button>
//           {!member.highlight && (
//             <Button variant="outline-secondary" className={styles.btn}>
//               Remove
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   );
// };

// const AddMemberCard = () => {
//   return (
//     <Card className={styles.addCard}>
//       <Card.Body className={styles.addBody} 
//       onClick={handleShows}
//       >
//         <div className={styles.plus}>+</div>
//         <h6 className={styles.addTitle}>Add Household Member</h6>
//         <p className={styles.addText}>
//           Tap to add a spouse, child, parent, or other member of your household
//         </p>
//       </Card.Body>
//     </Card>
//   );
// };

export default function HouseholdMembers() {
  const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [middleName, setMiddleName] = useState("");
const [dob, setDob] = useState("");
const [gender, setGender] = useState("");

const [relationship, setRelationship] = useState("");
const [maritalStatus, setMaritalStatus] = useState("");

const [education, setEducation] = useState("");
const [occupation, setOccupation] = useState("");

  const [disability, setDisability] = useState("");
  const [chronic, setChronic] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [shows, setShows] = useState(false);
        const handleShows = () => setShows(true);
    const handleCloses = () => {
      setShows(false);
      setSelectedData(null);
      setIsEdit(false);
      };


    
    const [saving, setSaving] = useState(false);


       const handleSubmit = async () => {
  setSaving(true);

  try {
    const token = localStorage.getItem("userToken");

      const formData = new FormData();

    //     if (itfFile2 && itfFile2.length > 0) {
    //   itfFile2.forEach(file => {
    //     formData.append("cv[]", file);
    //   });
    //   }
    //     if (itfFile1 && itfFile1.length > 0) {
    //   itfFile1.forEach(file => {
    //     formData.append("academic_credential[]", file);
    //   });
    //   }

    // formData.append("first_name", firstName);
    // formData.append("surname", surname);
    // formData.append("other_names", otherNames);
    // formData.append("phone_number", phone);
    // formData.append("email", email);
    // formData.append("state", state);
    // formData.append("address", address);
    // formData.append("gender", gender);
    // formData.append("dob", dob);

    // if (isEdit) {
    //   // UPDATE API
    //   await axios.post(
    //     `${BASE_URL}/company/update-personnel?id=${selectedData.id}`,
    //     formData,
    //     {
    //       headers: {
    //       //  "Content-Type": "multipart/form-data",
    //       Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   Swal.fire("Updated!", "Personnel updated successfully", "success");
    // } else {
    //   // CREATE API
    //   await axios.post(
    //     `${BASE_URL}/company/add-personnel`,
    //     formData,
    //     {
    //       headers: {
    //         // "Content-Type": "multipart/form-data",
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   Swal.fire("Success!", "Personnel added successfully", "success");
    // }

    // fetchPersonnel();
    // handleCloses(); // close modal properly
  } catch (error) {
    Swal.fire("Error", "Something went wrong", "error");
  } finally {
    setSaving(false);
  }
};


  return (
    <div>
      <NewHeader />
      
    <div className={styles.wrapper}>

      <Modal show={shows} 
      size="lg"
      onHide={handleCloses} 
      centered
      >
  <div className={styles.modalBody}>
    
    {/* HEADER */}
    <div className={styles.header}>
      <h5 className={styles.mtitle}>
        {isEdit ? "Edit Household Member" : "Add Household Member"}
      </h5>

      <IoClose className={styles.closeIcon} onClick={handleCloses} />
    </div>

    {/* <hr className={styles.dividers} /> */}

    {/* FORM */}
    <Form className={styles.forms}>

      {/* FIRST + LAST NAME */}
      <Row>
        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>First Name</Form.Label>
            <Form.Control
              className={styles.finput}
              placeholder="enter first name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
        </Col>

        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Last Name</Form.Label>
            <Form.Control
              className={styles.finput}
              placeholder="enter last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
        </Col>
      </Row>

      {/* MIDDLE NAME */}
      <div className={styles.formGroup}>
        <Form.Label className={styles.txtlab}>Middle Name</Form.Label>
        <Form.Control
          className={styles.finput}
          placeholder="enter middle name"
          value={middleName}
          onChange={(e) => setMiddleName(e.target.value)}
        />
      </div>

      {/* DOB + GENDER */}
      <Row>
        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Date of Birth</Form.Label>
            <Form.Control
              type="date"
              className={styles.finput}
              value={dob}
              onChange={(e) => setDob(e.target.value)}
            />
          </div>
        </Col>

        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Gender</Form.Label>
            <Form.Select
              className={styles.finput}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </Form.Select>
          </div>
        </Col>
      </Row>

      {/* RELATIONSHIP + MARITAL STATUS */}
      <Row>
        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Relationship to Head</Form.Label>
            <Form.Select
              className={styles.finput}
              value={relationship}
              onChange={(e) => setRelationship(e.target.value)}
            >
              <option value="">select</option>
              <option>Spouse</option>
              <option>Child</option>
              <option>Relative</option>
            </Form.Select>
          </div>
        </Col>

        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Marital Status</Form.Label>
            <Form.Select
              className={styles.finput}
              value={maritalStatus}
              onChange={(e) => setMaritalStatus(e.target.value)}
            >
              <option value="">select</option>
              <option>Single</option>
              <option>Married</option>
            </Form.Select>
          </div>
        </Col>
      </Row>

      {/* EDUCATION + OCCUPATION */}
      <Row>
        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Highest Level of Education</Form.Label>
            <Form.Select
              className={styles.finput}
              value={education}
              onChange={(e) => setEducation(e.target.value)}
            >
              <option value="">select</option>
              <option>Primary</option>
              <option>Secondary</option>
              <option>Tertiary</option>
            </Form.Select>
          </div>
        </Col>

        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Occupation</Form.Label>
            <Form.Select
              className={styles.finput}
              value={occupation}
              onChange={(e) => setOccupation(e.target.value)}
            >
              <option value="">select</option>
            </Form.Select>
          </div>
        </Col>
      </Row>

      {/* DISABILITY + CHRONIC */}
      <Row>
        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Any Disability?</Form.Label>
            <Form.Select
              className={styles.finput}
              value={disability}
              onChange={(e) => setDisability(e.target.value)}
            >
              <option value="">select</option>
              <option>Yes</option>
              <option>No</option>
            </Form.Select>
          </div>
        </Col>

        <Col md={6}>
          <div className={styles.formGroup}>
            <Form.Label className={styles.txtlab}>Chronic Illness?</Form.Label>
            <Form.Select
              className={styles.finput}
              value={chronic}
              onChange={(e) => setChronic(e.target.value)}
            >
              <option value="">select</option>
              <option>Yes</option>
              <option>No</option>
            </Form.Select>
          </div>
        </Col>
      </Row>

    </Form>

    {/* FOOTER */}
    <div className={styles.footer}>
      <button className={styles.closeBtn} onClick={handleCloses}>
        Cancel
      </button>

      <button
        disabled={saving}
        onClick={handleSubmit}
        className={styles.saveBtn}
      >
        {saving ? "Saving..." : isEdit ? "Save Changes" : "Add Member"}
      </button>
    </div>

  </div>
</Modal>

      <div className={styles.headerRow}>
        <div>
          <p className={styles.smallHeader}>— HOUSEHOLD</p>
          <h3 className={styles.title}>Household Members</h3>
          <p className={styles.subtitle}>
            Manage the members registered under your household
          </p>
        </div>

        <button className={styles.addBtn}
        onClick={handleShows} 
        >
        + Add Members
        </button>
      </div>

      <Row className="g-4">
        {members.map((member, index) => (
          <Col lg={4} md={12} sm={12} key={index}>
             <Card className={`${styles.card} ${member.highlight ? styles.highlight : ""}`}>
      <Card.Body>
        <div className={styles.avatar} style={{ background: member.color }}>
          {member.initials}
        </div>

        <h5 className={styles.name}>{member.name}</h5>
        <p className={styles.role}>{member.role}</p>

        <div className={styles.infoRow}>
          <span>Date of Birth</span>
          <span>{member.dob}</span>
        </div>

        <div className={styles.infoRow}>
          <span>Gender</span>
          <span>{member.gender}</span>
        </div>

        <div className={styles.infoRow}>
          <span>Education</span>
          <span>{member.education}</span>
        </div>

        <div className={styles.infoRow}>
          <span>Occupation</span>
          <span>{member.occupation}</span>
        </div>

        <div className={styles.actions}>
          <button
          className={styles.btnedit}
           onClick={() => {
                  setIsEdit(true);
                  setSelectedData(""); 
                  // setSelectedData(item); 
                  handleShows();
                }}
          >
            Edit Profile
          </button>
          {!member.highlight && (
            <button variant="outline-secondary" className={styles.btnrm}>
              Remove
            </button>
          )}
        </div>
      </Card.Body>
    </Card>
          </Col>
        ))}

        <Col lg={4} md={12} sm={12}>
             <Card className={styles.addCard}>
      <Card.Body className={styles.addBody} 
      onClick={handleShows} 
      >
      <div className={styles.contcad}>
        <div className={styles.plus}>+</div>
        <h6 className={styles.addTitle}>Add Household Member</h6>
        <p className={styles.addText}>
          Tap to add a spouse, child, parent, or other member of your household
        </p>
        </div>
      </Card.Body>
    </Card>
        </Col>
      </Row>

    </div>

    </div>
  );
}
